import * as types from 'modules/devices/actionTypes';
import type { SelectDeviceAction, SetUpdateModalVisibilityAction } from 'modules/devices/types';
import { LOCATION_CHANGE } from 'modules/router/actionTypes';
import { createReducer } from 'utils/ReduxUtils';

export const initialState: string | null = null;

const selectOne = (_: string | null, { payload }: SelectDeviceAction) => payload;

const reset = () => initialState;

const resetOnClose = (state: string | null, { payload }: SetUpdateModalVisibilityAction) =>
  (payload ? state : initialState);

export default createReducer<string | null>(initialState, {
  [LOCATION_CHANGE]: reset,
  [types.SELECT_DEVICE]: selectOne,
  [types.PATCH_DEVICE_SUCCESS]: reset,
  [types.SET_UPDATE_MODAL_VISIBILITY]: resetOnClose,
});
